import React, { Component } from 'react';
import { Button, Row, Col, Card } from 'antd';
import { QRCode } from 'react-qr-svg';

class PrintQRView extends Component {
    constructor(props) {
        super(props);
        this.print = this.print.bind(this);
    }

    /* global  document window */
    print() {
        const printContents = document.getElementById('printArea').innerHTML;
        const originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }

    render() {
        return (
            <div>
                <Button type="primary" onClick={this.print}>
                    Print
                </Button>
                <Row gutter={8} id="printArea">
                    <h2 style={{ padding: '10pt' }}>{this.props.company.name}</h2>
                    { this.props.machines.map(m => (
                        <Col xs={24} sm={12} md={8}>
                            <Card.Grid className="single-card">
                                <h3>
                                    {m.name}
                                </h3>
                                <QRCode
                                    bgColor="#FFFFFF"
                                    fgColor="#000000"
                                    level="Q"
                                    style={{ width: '50%' }}
                                    value={`${m.companyid}@@@${m.key}`}
                                />
                            </Card.Grid>
                        </Col>
                    ))}
                </Row>
            </div>
        );
    }
}

export default PrintQRView;



// WEBPACK FOOTER //
// ./src/components/views/PrintQRView.js